export default __webpack_public_path__ + "static/media/bottomArrow.9eb5648e.svg";